export const QR_IMG = 'https://cdn.vip-wifi.com/fangchan/img/qr/chengdu/loan-computer.jpg'

export const PREPAYMENT_CALC_LINK = '/packageA/prepayment_calc/main'

export const OTHER_TOOLS = [
    {
        url: '/packageA/loan_computer/share/help',
        type: 'help',
        name: '计算帮助'
    },
    {
        url: '/packageA/taxes_calculate/main',
        type: 'tax',
        name: '税费计算'
    },
    {
        url: PREPAYMENT_CALC_LINK,
        type: 'integral',
        name: '提前还款计算'
    }
]